import { useEffect, RefObject } from 'react';

const EDGE_GUARD_PX = 20;

export const usePreventGestures = (containerRef: RefObject<HTMLElement | null>) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const preventEdgeSwipe = (event: TouchEvent) => {
      const touch = event.touches[0];
      if (!touch) return;
      if (touch.pageX < EDGE_GUARD_PX || touch.pageX > window.innerWidth - EDGE_GUARD_PX) {
        event.preventDefault();
      }
    };

    const preventPinchZoom = (event: TouchEvent) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    };

    const preventGesture = (event: Event) => {
      event.preventDefault();
    };

    container.addEventListener('touchstart', preventEdgeSwipe, { passive: false });
    container.addEventListener('touchmove', preventPinchZoom, { passive: false });
    document.addEventListener('gesturestart', preventGesture);

    return () => {
      container.removeEventListener('touchstart', preventEdgeSwipe);
      container.removeEventListener('touchmove', preventPinchZoom);
      document.removeEventListener('gesturestart', preventGesture);
    };
  }, [containerRef]);
};
